




































import { Component, Vue, Prop } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import ConfirmModal from '@/shared/components/ConfirmModal.vue';
import formatNumber from '@/shared/filters/format-number';
import { PayAuthorityModel } from '@/models/payauthority';
import { DATA } from '@/config/data';
import { APP_CONFIG } from '@/config/app-config';
import payauthorityServices from '@/services/payauthority-services';
import authService from '@/services/auth-services';

@Component({
    components: {
        ConfirmModal,
        Loading
    }
})
export default class PayAuthorityDetailFooter extends Vue {
    @Prop({default: null})
    private payauthority!: PayAuthorityModel;
    @Prop({default: {}})
    private customerInfo: any;
    
    private eventEmit = {
        eventCancelOrder: 'eventCancelOrder',
        eventPayOrder: 'eventPayOrder',
        eventReportOrder: 'eventReportOrder'
    };
    private actions = {
        cancel: 'cancel',
        process: 'process',
        report: 'report',
    };
    private actionSelected: any = this.actions.cancel;
    private isConfirm = false;
    private showNextConfirm = true;
    private isLoading = false;
    private modalContent = 'Bạn có thực sự muốn hủy đơn hàng này không?';

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get statusDetail() {
      return this.payauthority ? DATA.payauthorityStatus.find(s => s.value == this.payauthority.Status) : null;
    }

    private async complainOrder() {
        if(this.payauthority && this.payauthority.ID) {
            this.$router.push({ name: 'payauthority-complain', params: { orderId: this.payauthority.ID.toString(), orderType: '3' } });
        }
    }

    private async onActionStatus(action: any) {
        this.actionSelected = action;
        switch(this.actionSelected) {
            case this.actions.cancel: {
                this.modalContent = 'Bạn có thực sự muốn hủy đơn ủy quyền này không?';
                this.isConfirm = true;
                this.showNextConfirm = true;
                break;
            }
            case this.actions.report: {
                this.$emit(this.eventEmit.eventReportOrder);
                break;
            }
            case this.actions.process: {
                if (this.payauthority.OrderCodes) {
                    const error = this.payauthority.OrderCodes.find(c => !c.Amount || !c.PayID || !c.OrderCode);
                    if (this.payauthority.OrderCodes.length != this.payauthority.NumberDetail)  {
                        Vue.notify({
                            group: 'foo',
                            type: 'error',
                            title: 'Thông báo!',
                            text: `Số lệnh đã tạo chưa khớp với số lệnh yêu cầu thanh toán ban đầu`,
                        });
                        break;
                    }
                    if (error) {
                        Vue.notify({
                            group: 'foo',
                            type: 'error',
                            title: 'Thông báo!',
                            text: `Các trường Giá trị, mã đơn và tài khoản ủy quyền bắt buộc phải nhập trong mỗi lệnh`,
                        });
                        break;
                    }
                    let amountTotal = this.payauthority.OrderCodes.map(o => o.Amount).reduce((a, b) => Number(a) + Number(b), 0) || 0;
                    amountTotal = Math.round(amountTotal * 100) / 100;
                    if (Number(amountTotal) !== Number(this.payauthority.Amount)){
                        Vue.notify({
                            group: 'foo',
                            type: 'error',
                            title: 'Thông báo!',
                            text: `Tổng giá trị các lệnh không bằng giá trị yêu cần ủy quyền thanh toán ban đầu`,
                        });
                        break;
                    }
                } else {
                    break;
                }
                this.modalContent = `<div style="color: #111">Số tiền bạn yêu cầu thanh toán ủy quyền là <label class="fb text-danger">${ formatNumber(this.payauthority.TotalAmount, '0,0') } vnđ.</label>
                                    <div>Bạn có muốn thanh toán không?</div></div>`;
                this.isConfirm = true;
                this.showNextConfirm = true;
                break;
            }
        }
    }

    private onCloseModal(eventData: any) {
        this.isConfirm = !eventData.close || false;
    }

    private onAcceptModal(eventData: any) {
        this.isConfirm = !eventData.close || false;
        if (eventData.data === 'OK' && this.actionSelected === this.actions.cancel) {
            this.onCancelOrder();
        } else if (eventData.data === 'OK' && this.actionSelected === this.actions.process) {
            this.onProcessOrder();
        }
    }

    private async onCancelOrder() {
        this.isLoading = true;
        const dataRequest =  {
            Status: 1
        };
        this.isLoading = false;
        const result = await payauthorityServices.updateDetail(this.payauthority.ID || 0, dataRequest);
        
        if (result && result.status === 200 && result.data.status === 200) {
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Hủy đơn ủy quyền thành công!',
            });
            this.$emit(this.eventEmit.eventCancelOrder, { status: 1 });
            this.isLoading = false;
        }
    }

    private async onProcessOrder() {
        if (this.payauthority && this.payauthority.OrderCodes) {
            this.isLoading = true;
            const dataRequest = {
                Status: 5,
                OrderCodes: this.payauthority.OrderCodes
            };
            const result: any = await payauthorityServices.updateDetail(Number(this.payauthority.ID), dataRequest);
            if (result && result.status === 200 && result.data.status === 200) {
                Vue.notify({
                    group: 'foo',
                    type: 'success',
                    title: 'Thông báo!',
                    text: 'Thanh toán thành công!',
                });
                this.$emit(this.eventEmit.eventPayOrder, { status: 5 });
                this.isLoading = false;
            } else {
                this.isLoading = false;
                const error = result.data.error ?result.data.error : `Có lỗi khi cập nhật hệ thống!`;
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thông báo!',
                    text: error,
                });
            }
        }
    }

    private async getCustomersInfo() {
        if (this.userInfo.userId > 0) {
            const result = await authService.customersInfo(this.userInfo.userId);
            if(result && result.status === 200) {
                (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
            }
        }
    }
}
